import { isValidQuery } from "components/hostedScrapingValidators";
import { SDEContent } from "./sdecontentTypes";

export const GoogleGeminiContent: SDEContent = {
  projectType: 'async_google_gemini',
  projectCategory: 'google',
  apiUrlFn: (apiHost: string) => {
    return `${apiHost}/structured/google/gemini/v1`;
  },
  docsSection: '',
  docsSectionTitle: '',
  docsSectionAsync: '',
  docsSectionAsyncTitle: '',
  inputKey: 'query',
  inputsKey: 'queries',
  validatorFunction: isValidQuery,
  newProjectEditProject: {
    inputBoxLabels: {
      listLiteralInputTitle: 'Prompts',
      listLiteralInputPlaceholder: 'Enter one prompt per line.',
    },
    inputSectionLabels: {
      inputSectionTitle: 'Input prompts',
      inputSectionDescription: "Enter the prompts you want to send to Gemini.",
    },
    projectContent: {
      title: 'Gemini',
      description: 'Send prompts to Google Gemini and receive structured answers with sources.',
      icon: 'google',
      inputTitle: 'Prompt',
    },
  },
  apiPlayground: {
    inputSectionLabels: {
      inputSectionTitle: 'Input prompts',
      inputSectionDescription: 'Enter the prompts you want to send to Gemini.',
    },
    projectContent: {
      title: 'Gemini',
      description: 'Send prompts to Google Gemini and receive structured answers with sources.',
      icon: 'google',
    },
    enterInputsPlaceholder: 'Enter a prompt for Gemini',
    enterInputsMessage: 'Enter a prompt for Gemini',
    codeViewPlaceHolder: 'Please provide a valid prompt',
    dropdownTitle: 'Gemini'
  }
};
